import { useCallback } from 'react';

import { AttioBrandMark } from '@/components/integrations/ProviderBrandMarks';
import { useOrg } from '@/contexts/OrgContext';
import { useFeatureFlag } from '@/hooks/useFeatureFlag';
import { useCanWrite } from '@/hooks/usePermissions';
import {
  VendorImportCard,
  type VendorImportWizardHandoff,
} from '@/lib/vendor-import';

import { AttioImportWizard } from './AttioImportWizard';

export function AttioImportCard() {
  const enabled = useFeatureFlag('attio_import');
  const { currentOrg } = useOrg();
  const orgId = currentOrg?.id;
  const canWrite = useCanWrite();

  const renderWizard = useCallback(
    (handoff: VendorImportWizardHandoff) => (
      <AttioImportWizard
        orgId={handoff.orgId}
        isOpen={handoff.isOpen}
        onClose={handoff.onClose}
        onImportCreated={handoff.onImportCreated}
      />
    ),
    []
  );

  if (!enabled) {
    return null;
  }

  return (
    <VendorImportCard
      orgId={orgId}
      title='Import from Attio'
      description='Paste your Attio API key to bring your people and companies into Ahoy.'
      ctaLabel='Connect Attio'
      icon={<AttioBrandMark className='size-5 text-fg-primary' />}
      renderWizard={renderWizard}
      showCta={canWrite}
    />
  );
}
